import axiosInstance from 'api/axiosConfig'
import { ENDPOINTS } from 'api/endpoints'

export type PasswordResetResponse = {
  success: boolean
  sent?: boolean
  message?: string
  code?: string
}

export async function requestPasswordResetEmail(
  email: string
): Promise<PasswordResetResponse> {
  const res = await axiosInstance.post<PasswordResetResponse>(
    ENDPOINTS.PASSWORD_RESET.BASE,
    { email: email.trim().toLowerCase() },
    // Admin token + SMTP often takes a few seconds.
    { timeout: 30000 }
  )
  return res.data
}
